var map = {
	"./stampa (1).webp": 982,
	"./stampa (10).webp": 340,
	"./stampa (11).webp": 2255,
	"./stampa (12).webp": 1833,
	"./stampa (13).webp": 4353,
	"./stampa (14).webp": 4438,
	"./stampa (15).webp": 5226,
	"./stampa (16).webp": 4246,
	"./stampa (17).webp": 8045,
	"./stampa (18).webp": 9416,
	"./stampa (2).webp": 6491,
	"./stampa (3).webp": 867,
	"./stampa (4).webp": 6319,
	"./stampa (5).webp": 8148,
	"./stampa (6).webp": 7860,
	"./stampa (7).webp": 9846,
	"./stampa (8).webp": 6039,
	"./stampa (9).webp": 3401
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1542;